import { Brain, Github, Mail, Globe } from 'lucide-react'

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-ai-500 to-ai-700 rounded-lg flex items-center justify-center">
                <Brain className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">AIWorldMeter</span>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              实时监测AI在全球各行业和国家的渗透率，通过数据可视化展示人工智能发展的全貌。
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Github className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Mail className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <Globe className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">快速链接</h3>
            <ul className="space-y-2">
              <li><a href="/industries" className="text-gray-400 hover:text-white transition-colors">行业分析</a></li>
              <li><a href="/countries" className="text-gray-400 hover:text-white transition-colors">国家数据</a></li>
              <li><a href="/news" className="text-gray-400 hover:text-white transition-colors">AI新闻</a></li>
              <li><a href="/about" className="text-gray-400 hover:text-white transition-colors">关于我们</a></li>
            </ul>
          </div>

          {/* Data Sources */}
          <div>
            <h3 className="text-lg font-semibold mb-4">数据来源</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">McKinsey & Company</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">Stanford HAI</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">OECD AI Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors">World Bank</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 AIWorldMeter.com. 保留所有权利。</p>
          <p className="mt-2 text-sm">数据仅供参考，请以官方发布为准。</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer 